export default __webpack_public_path__ + "static/media/acoustic_illu.673486a3.svg";